"use strict";

exports.__esModule = true;
function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

exports.default = guard;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/polished/lib/internalHelpers/_guard.js
// module id = 15
// module chunks = 58787633285632 154861247209503 189597454788034